@import '../../../../../constants/spacing.module.less';

.readonly-input-box {
  padding: @space-4;
}
